export default function Dashboard(){return <div className='p-8'>Dashboard</div>}